import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import LiquidEtherDefault from "../LiquidEtherDefault";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/home-main.svg";
import Toolstack from "../About/Toolstack";

function About() {
  return (
    <Container fluid className="about-section">
      <LiquidEtherDefault />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              Know <strong className="purple">Me</strong> Better
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" style={{ maxWidth: "400px", height: "auto" }}
 />
          </Col>
        </Row>
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>

        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">Tools</strong> Used
        </h1>
        <Toolstack />

        <Github />
      </Container>
    </Container>
  );
}

export default About;
